// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Management
const AccountingPage = () => import('@/modules/accounting/views/AccountingPage')
const AccountingDashboard  = () => import('@/modules/accounting/views/AccountingDashboard')

const AccountingVerifyClosersList = () => import('@/modules/accounting/views/AccountingVerifyClosersList');
const AccountingHoldEscalateList = () => import('@/modules/accounting/views/AccountingHoldEscalateList');
const AccountingPayrollReadyList = () => import('@/modules/accounting/views/AccountingPayrollReadyList');
const AccountingAddEquipmentList = () => import('@/modules/accounting/views/AccountingAddEquipmentList');
const AccountingNotPayableList = () => import('@/modules/accounting/views/AccountingNotPayableList');
const AccountingPaidList = () => import('@/modules/accounting/views/AccountingPaidList');


var routes = [
    {
        path: '/accounting',
        redirect: '/accounting/dashboard',
        name: 'Accounting',
        component: DefaultContainer,
        children: [
            {
				path: '/accounting',
                name: 'AccountingPage',
				redirect: '/accounting/dashboard',
                component: AccountingPage,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
				children: [
					{
						path: 'dashboard',
						name: 'AccountingDashboard',
						component: AccountingDashboard,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'dashboard',
							role_filter: 'closer',
						},
					},
					{
						path: 'verify-closers',
						name: 'AccountingVerifyClosersList',
						component: AccountingVerifyClosersList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'verify-closers',
							role_filter: 'closer',
						},
					},
					{
						path: 'hold-escalate',
						name: 'AccountingHoldEscalateList',
						component: AccountingHoldEscalateList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'hold-escalate',
							role_filter: 'closer',
						},
					},
					{
						path: 'payroll-ready',
						name: 'AccountingPayrollReadyList',
						component: AccountingPayrollReadyList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'payroll-ready',
							role_filter: 'closer',
						},
					},
					{
						path: 'add-equipment',
						name: 'AccountingAddEquipmentList',
						component: AccountingAddEquipmentList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'add-equipment',
							role_filter: 'closer',
						},
					},
					{
						path: 'not-payable',
						name: 'AccountingNotPayableList',
						component: AccountingNotPayableList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'not-payable',
							role_filter: 'closer',
						},
					},
					{
						path: 'paid',
						name: 'AccountingPaidList',
						component: AccountingPaidList,
						meta: {
							requiresAuth: true,
							permission: false,
							tab: 'paid',
							role_filter: 'closer',
						},
					},
				]
            },
        ]
    },
];

export default routes;
